import { render } from "./SellerShippingLogistics.vue?vue&type=template&id=2c1c24cf"
import script from "./SellerShippingLogistics.vue?vue&type=script&lang=js"
export * from "./SellerShippingLogistics.vue?vue&type=script&lang=js"

import "./SellerShippingLogistics.vue?vue&type=style&index=0&id=2c1c24cf&lang=scss"

import exportComponent from "/home/user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__